/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterUnlockRosterCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterUnlockRosterCtrl', ["dialog", "$state", "$scope", "Rosters", function(dialog, $state, $scope, Rosters) {
    $scope.unlockingRoster = false;

    $scope.unlockRoster = function() {
        $scope.unlockingRoster = Rosters.unlockRoster($scope.$resolve.roster);
        $scope.unlockingRoster.then(function() {
          $state.reload();
          dialog.close();
        });
      };
  }]);
